export const EXTERNAL_ONBOARDING_CHANGE_STEP = 'EXTERNAL_ONBOARDING_CHANGE_STEP';
export const EXTERNAL_ONBOARDING_DECREMENT_STEP = 'EXTERNAL_ONBOARDING_DECREMENT_STEP';
export const EXTERNAL_ONBOARDING_INCREMENT_STEP = 'EXTERNAL_ONBOARDING_INCREMENT_STEP';
